var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loding"},[_c('van-overlay',{staticClass:"show_lod",attrs:{"show":true}},[_c('van-loading',{staticClass:"lod",attrs:{"type":"spinner","vertical":""}},[_vm._v("加载中...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }